import { createSlice } from '@reduxjs/toolkit';

const initialState: {
    bankAccountId: number | undefined
} = {
  bankAccountId: undefined
}

export const payorderImportUISlice = createSlice({
  name: 'payorderImportUI',
  initialState: initialState,
  reducers: {
    setBankAccountId(state, action) {
      state.bankAccountId = action.payload;
    }
  },
}
);

export const { reducer: payorderImportUIReducer, actions: payorderImportUIActions } = payorderImportUISlice;